import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const EmailConfirmationInput = ({ value, onChange, error, onValidation }) => {
  const [email, setEmail] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [isTouched, setIsTouched] = useState(false);

  const validateEmail = (emailValue) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(emailValue);
  };

  const handleEmailChange = (e) => {
    const inputValue = e.target.value;
    setEmail(inputValue);
    setIsTouched(true);
    
    const valid = inputValue === '' || validateEmail(inputValue);
    setIsValid(valid);
    
    onChange(inputValue);
    onValidation(valid);
  };

  const handleBlur = () => {
    setIsTouched(true);
  };

  useEffect(() => {
    if (value !== undefined) {
      setEmail(value);
      setIsValid(value === '' || validateEmail(value));
    }
  }, [value]);

  const showValidation = isTouched && email !== '';
  const showError = isTouched && email !== '' && !isValid;

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-text-primary font-inter">
        Adresse e-mail *
      </label>
      
      <div className="relative">
        <Input
          type="email"
          value={email}
          onChange={handleEmailChange}
          onBlur={handleBlur}
          placeholder="exemple@domaine.fr"
          className={`w-full ${error || showError ? 'border-error focus:ring-error' : showValidation && isValid ? 'border-success focus:ring-success' : ''}`}
        />
        
        {/* Validation Icon */}
        {showValidation && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3">
            {isValid ? (
              <Icon name="CheckCircle" size={20} color="var(--color-success)" />
            ) : (
              <Icon name="AlertCircle" size={20} color="var(--color-error)" />
            )}
          </div>
        )}
      </div>

      {/* Helper Text */}
      <div className="flex items-center space-x-2 text-xs text-text-secondary font-inter">
        <Icon name="Info" size={14} />
        <span>
          Nous utiliserons cette adresse pour vous envoyer des confirmations importantes
        </span>
      </div>

      {/* Error Message */}
      {(error || showError) && (
        <div className="flex items-center space-x-2 text-sm text-error font-inter">
          <Icon name="AlertCircle" size={16} />
          <span>{error || 'Veuillez entrer une adresse e-mail valide'}</span>
        </div>
      )}

      {/* Success Message */}
      {showValidation && isValid && email && !error && (
        <div className="flex items-center space-x-2 text-sm text-success font-inter">
          <Icon name="CheckCircle" size={16} />
          <span>Adresse e-mail valide</span>
        </div>
      )}
    </div>
  );
};

export default EmailConfirmationInput;